module.exports = __webpack_public_path__ + "img/complaints_card1.fcacc8f4.png";